<h1  mat-dialog-title>Please confirm:</h1>

<h3>{{message}}</h3>

<button mat-raised-button color="primary" (click)="continue()">
    Continue
</button>
<button mat-raised-button color="warn" (click)="cancel()">
    Cancel
</button>